var _defaultBreakpoints;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * All potential screen sizes.
 */
export var ScreenSize;
/**
 * Names of all screen size literals.
 */

(function (ScreenSize) {
  ScreenSize[ScreenSize["xsmall"] = 0] = "xsmall";
  ScreenSize[ScreenSize["small"] = 1] = "small";
  ScreenSize[ScreenSize["medium"] = 2] = "medium";
  ScreenSize[ScreenSize["large"] = 3] = "large";
})(ScreenSize || (ScreenSize = {}));

/**
 * The default maximum screen width for each screen size. If the window
 *    width is less-than or equal to this amount, the screen will
 *    be considered that size.
 */
export var defaultBreakpoints = (_defaultBreakpoints = {}, _defineProperty(_defaultBreakpoints, ScreenSize.xsmall, 375), _defineProperty(_defaultBreakpoints, ScreenSize.small, 600), _defineProperty(_defaultBreakpoints, ScreenSize.medium, 1280), _defineProperty(_defaultBreakpoints, ScreenSize.large, Number.POSITIVE_INFINITY), _defaultBreakpoints);